<template>
  <div class="container">
    <div class="logistics">
      <div class="items">
        <div class="item-span">姓名</div>
        <div class="item-input">
          <input type="text" placeholder="请输入姓名" class="input" v-model="username" />
        </div>
      </div>
    </div>
    <div class="xian"></div>
    <div class="mation">
      <van-field
        class="mation-vanfield"
        readonly
        clickable
        label="性别："
        :value="value"
        :right-icon="icons"
        @click="showPicker = true"
      />
      <div class="mationvanpop">
        <van-popup class="mation-vanpop" v-model="showPicker" round position="bottom">
          <van-picker
            class="mation-vanpicker"
            show-toolbar
            title="性别"
            confirm-button-text="确定"
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
          ></van-picker>
        </van-popup>
      </div>
    </div>
    <div class="xian"></div>
    <div class="logistics">
      <div class="items">
        <div class="item-span">个人邮箱</div>
        <div class="item-input">
          <input
            type="text"
            v-model="useremail"
            placeholder="请输入个人邮箱"
            class="input"
          />
        </div>
      </div>
    </div>
    <div class="btn" @click="submint()">保存</div>
  </div>
</template>

<script>
import { updateMemberInfo, queryMemberInfo } from "@/api/api";
export default {
  data() {
    return {
      value: "男",
      showPicker: false,
      columns: ["男", "女"],
      icons: require("../../../assets/icon/icon_more.png"),
      useremail: "",
      username: "",
    };
  },
  methods: {
    onConfirm(value) {
      this.value = value;
      this.showPicker = false;
    },
    async submint() {
      var reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
      if (!reg.test(this.useremail) && this.useremail) {
        this.$toast("请输入正确邮箱号");
        return;
      }
      const params = {
        name: this.username,
        sex: this.value == "男" ? 1 : 2,
        email: this.useremail,
      };
      const res = await updateMemberInfo(params);
      if (res.code === "0000") {
        this.$toast("保存成功");
      } else {
        this.$toast(res.msg);
      }
    },
    async queryMemberInfo() {
      let res = await queryMemberInfo();
      console.log(res);
      this.username = res.data.name;
      this.useremail = res.data.email;
      this.value = res.data.sex == 1 ? "男" : "女";
    },
  },
  created() {
    this.queryMemberInfo();
  },
};
</script>

<style scoped lang="scss">
.container {
  margin-top: 20px;

  .logistics {
    padding: 0 30px;
    background-color: #fff;

    .items {
      display: flex;
      padding-top: 35px;
      padding-bottom: 35px;

      .item-span,
      .item-input {
        flex: 1;
      }

      .item-span {
        font-size: 30px;
        font-weight: 500;
        color: #333333;
        line-height: 40px;
      }

      .input {
        -webkit-box-pack: end;
        -webkit-justify-content: flex-end;
        justify-content: flex-end;
        text-align: right;
        font-size: 28px;
        font-weight: 500;
        color: #999999;
        line-height: 40px;
        border: 0;
      }
    }
  }

  .xian {
    width: 710px;
    height: 1px;
    border: 1px solid #efefef;
  }

  .Payment {
    padding-top: 35px;
    padding-bottom: 37px;
    padding-left: 30px;
    padding-right: 30px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .payspan {
      span {
        display: block;
      }

      .refund {
        font-size: 30px;
        font-family: Helvetica;
        color: #333333;
        line-height: 34px;
        padding-bottom: 5px;
      }

      .payagree {
        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #999999;
        line-height: 40px;
      }
    }

    .payimg {
      width: 32px;
      height: 32px;
    }
  }

  .mation {
    background: #ffffff;
    box-shadow: 0px 0px 2px 0px rgba(51, 51, 51, 0.15);
    .mation-vanfield {
      padding: 35px 30px;
    }
  }

  .paymt {
    padding-top: 35px;
    padding-bottom: 31px;
  }

  .btn {
    font-size: 36px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    width: 580px;
    height: 88px;
    line-height: 88px;
    margin: 300px auto;
    background: #1e53a4;
    border-radius: 44px;
  }
}
</style>
